/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_No_Carriers_FoundInputs */

const en_orders_no_carriers_found = /** @type {(inputs: Orders_No_Carriers_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No carriers found.`)
};

const es_orders_no_carriers_found = /** @type {(inputs: Orders_No_Carriers_FoundInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se encontraron transportistas.`)
};

/**
* | output |
* | --- |
* | "No carriers found." |
*
* @param {Orders_No_Carriers_FoundInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_no_carriers_found = /** @type {((inputs?: Orders_No_Carriers_FoundInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_No_Carriers_FoundInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_no_carriers_found(inputs)
	return es_orders_no_carriers_found(inputs)
});